import React, { useState } from 'react';

import i18n from 'i18n-js';
import PropTypes from 'prop-types';
import { Card } from 'components/UI';
import BrokerInfoModal from 'components/Modals/BrokerInfoModal';
import { Button, ListItem, ListItemText } from '@material-ui/core';
import { useStyles, listItemsStyles, listTextStyles, customCardStyles } from './Brokers.styled';

const Brokers = ({ id, brokers = {}, menuOptions = [], title = '', type }) => {
  const classes = useStyles();
  const listClasses = listTextStyles();
  const cardClasses = customCardStyles();
  const listItemsClasses = listItemsStyles();
  const [currentBroker, setCurrentBroker] = useState(null);
  const [openBrokerModal, setOpenBrokerModal] = useState(false);

  const handleOpenBrokerModal = (broker) => {
    setCurrentBroker(broker);
    setOpenBrokerModal(true);
  };

  const handleCloseBrokerModal = () => {
    setOpenBrokerModal(false);
    setCurrentBroker(null);
  };

  const BrokerStatus = ({ status, details }) => {
    return status ? (
      <>
        <span className={`${status?.toLowerCase()}`}>
          {i18n.t(`status.${status}`, {
            defaultValue: status?.toLowerCase() || '--',
          })}
        </span>
        <span>{details?.toString()?.toLowerCase()?.replace(',', ', ')}</span>
      </>
    ) : (
      ''
    );
  };

  const BrokerLabel = ({ broker, label }) => {
    return (
      <>
        <p>{label}</p>
        <Button
          type="button"
          variant="text"
          color="primary"
          data-cy="borkers-more-info"
          disableFocusRipple={true}
          className={classes.button}
          onClick={() => handleOpenBrokerModal(broker)}
        >
          {i18n.t('common.more_info')}
        </Button>
      </>
    );
  };

  return (
    <Card
      menuItems={menuOptions}
      headerActionType="vertical"
      title={title || i18n.t('brokers.title')}
      data-cy="brokers-widget-card"
      contentRootClasses={cardClasses}
    >
      <div data-cy="brokers-widget-container">
        {Object.keys(brokers).length
          ? Object.keys(brokers).map((key, index) => (
              <ListItem key={index} classes={listItemsClasses}>
                <ListItemText
                  classes={listClasses}
                  primary={
                    <BrokerLabel
                      broker={brokers[key]}
                      label={i18n.t(
                        `brokers_slugs.${brokers[key].name || brokers[key].broker_slug}`,
                        {
                          defaultValue: brokers[key].name || brokers[key].broker_slug,
                        }
                      )}
                    />
                  }
                  secondary={
                    <BrokerStatus
                      status={brokers[key].status}
                      details={brokers[key]?.status_details}
                    />
                  }
                />
              </ListItem>
            ))
          : i18n.t('brokers.empty')}
      </div>
      {openBrokerModal && (
        <BrokerInfoModal
          vehicle_id={id}
          open={openBrokerModal}
          broker={currentBroker}
          handleClick={handleCloseBrokerModal}
          type={type}
        />
      )}
    </Card>
  );
};

Brokers.propTypes = {
  menuOptions: PropTypes.array,
  brokers: PropTypes.object.isRequired,
  id: PropTypes.number.isRequired,
  title: PropTypes.string,
  type: PropTypes.string,
  status: PropTypes.string,
  details: PropTypes.string,
  broker: PropTypes.object,
  label: PropTypes.string,
};

Brokers.defaultProps = {
  menuOptions: [],
};

export default Brokers;
